<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-06 13:22:20
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-11-04 17:31:30
 * @FilePath: /wemeet-admin-new/src/views/index/meetingData.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="meetingData-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <!-- <el-button type="success" @click="exportData(row, $event)">
          数据导出
        </el-button> -->
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item>
            <el-input v-model.trim="queryForm.meetingName" clearable placeholder="请输入会议名称" />
          </el-form-item>

          <el-form-item>
            <el-date-picker
              v-model="queryForm.time"
              end-placeholder="结束时间"
              range-separator="至"
              start-placeholder="开始时间"
              type="datetimerange"
            />
          </el-form-item>

          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <el-table v-loading="listLoading" border :data="list">
      <el-table-column align="center" label="展会code" prop="meetingCode" show-overflow-tooltip />
      <el-table-column align="center" label="开始时间">
        <template #default="{ row }">
          <span>{{ handleDate(row.startTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="结束时间">
        <template #default="{ row }">
          <span>{{ handleDate(row.endTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="会议名称" prop="meetingName" show-overflow-tooltip />
      <el-table-column align="center" label="管理员" prop="hostName" show-overflow-tooltip />
      <el-table-column align="center" label="签到总数" prop="signTotal" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag type="success">{{ row.signTotal }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="报名总数" prop="signUpTotal" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag type="success">{{ row.signUpTotal }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="新用户报名总数" prop="signNewUserTotal" show-overflow-tooltip>
        <template #default="{ row }">
          <el-tag type="success">{{ row.signNewUserTotal }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column align="center" label="会议码">
        <template #default="{ row }">
          <el-image :preview-src-list="[row.qrCodeUrl]" :src="row.qrCodeUrl" :zoom-rate="1.2" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" show-overflow-tooltip width="195">
        <template #default="{ row }">
          <!-- <el-button @click="handleEdit(row)" type="text">下载会议码</el-button> -->
          <el-button v-loading.fullscreen.lock="fullscreenLoading" type="text" @click="download(row)">
            报名信息导出
          </el-button>
          <el-button v-loading.fullscreen.lock="fullscreenLoading" type="text" @click="open(row)">短链生成</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNo"
      :layout="layout"
      :page-sizes="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <generateWx ref="generateWxRef" />
  </div>
</template>

<script>
  import { defineAsyncComponent, defineComponent, getCurrentInstance, onMounted, reactive, toRefs, computed } from 'vue'
  import { getAllHoldMeet } from '@/api/workBench'
  import { exportVisitorRegisterReport } from '@/api/exhibitionManage'
  import { Delete, Plus, Search } from '@element-plus/icons'
  import { useStore } from 'vuex'
  import { parseTime } from '@/utils/index'
  import generateWx from '@/components/generateWx/generateWx'
  import { dataExportB } from '@/api/exhibitionManage'
  export default defineComponent({
    name: 'MeetingData',
    components: {
      generateWx,
    },
    setup() {
      const { proxy } = getCurrentInstance()

      const store = useStore()
      const state = reactive({
        generateWxRef: null,
        list: [],
        listLoading: true,
        layout: 'prev, pager, next,total,sizes',
        total: 0,
        pageSize: [10, 20, 30, 50, 100],
        selectRows: '',
        queryForm: {
          pageNum: 1,
          pageSize: 10,
          endTime: '',
          meetingName: '',
          startTime: '',
        },
        fullscreenLoading: false,
      })

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }
      const queryData = () => {
        state.queryForm.pageNum = 1
        if (state.queryForm.time) {
          state.queryForm.startTime = new Date(state.queryForm.time[0]).getTime()
          state.queryForm.endTime = new Date(state.queryForm.time[1]).getTime()
        } else {
          state.queryForm.startTime = ''
          state.queryForm.endTime = ''
        }
        fetchData()
      }
      const fetchData = async () => {
        state.listLoading = true
        const { data } = await getAllHoldMeet(state.queryForm)
        state.list = data.data
        state.total = data.total
        state.listLoading = false
      }
      onMounted(() => {
        fetchData()
      })

      const download = (row) => {
        state.fullscreenLoading = true
        exportVisitorRegisterReport(row.meetingCode).then((res) => {
          state.fullscreenLoading = false
          if (res.data.success) {
            window.open(res.data.fileUrl)
          }
        })
      }
      const handleDate = (val) => {
        return parseTime(val)
      }

      const open = (row) => {
        console.log(row)
        const qrCodeParams = {
          autoColor: false,
          b: 0,
          env: '',
          g: 0,
          jumpPath: row.meetingCode,
          jumpType: '',
          logo: row.logo,
          params: `{"meetingCode":"${row.meetingCode}"}`,
          path: 'pages/index/index',
          r: 0,
          scenesType: 'USER_HOLD_MEETING',
          width: 1280,
        }
        state['generateWxRef'].handleOpen(row, qrCodeParams)
      }

      const exportData = async () => {
        const { data } = await dataExportB({ type: 'EXHIBITION_FORUM_REGISTER_REPORT' })
      }

      return {
        ...toRefs(state),
        handleSizeChange,
        handleCurrentChange,
        queryData,
        fetchData,
        Delete,
        Plus,
        Search,
        download,
        handleDate,
        open,
        exportData,
      }
    },
  })
</script>

<style>
  .meetingData-management-container .el-image-viewer__canvas {
    background: #fff;
  }
  .meetingData-management-container .el-image-viewer__mask {
    background-color: #fff !important;
  }
</style>
